import { BaseContainerModel } from '../base-container.model';
import { bl_ocr_item_hdr_RowClass } from '../../dbschema';

export class OCRItemContainerModel extends BaseContainerModel {
  bl_ocr_item_hdr: bl_ocr_item_hdr_RowClass = new bl_ocr_item_hdr_RowClass();
}
